import { MyNoiseGradadientBackground } from "../../components/backgrounds";
import { MyButton } from "../../components/MyButton";
import { useTranslation } from "react-i18next";

export const BannerSection: React.FC<{
  onClick: () => void;
}> = ({ onClick }) => {
  const { t } = useTranslation();
  
  return (
    <div className="banner__section section-container">
      <MyNoiseGradadientBackground vivid />
      <div className="banner-content">
        <div className="container h-100 d-flex flex-column justify-content-center">
        <div className="row h-100 align-items-center text-center g-5">
          <div className="col-md-6 h-100 d-flex flex-column justify-content-center align-items-center p-lg-5 p-1  order-2 order-md-1">
            <div className="banner__section__offer">
              <img 
                src="/assets/gifs/rocket.gif" 
                alt="Rocket animation - Entra nel futuro con EffAI"
                loading="lazy"
                decoding="async"
              />

              <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center">
                <div className="mb-3 mb-lg-0">
                  <h1>{t('landing:banner.offer.time')}</h1>
                  <h5>{t('landing:banner.offer.timeUnit')}</h5>
                </div>

                <div className="d-flex justify-content-center align-items-center h-100 ">
                  <p className="m-0">
                    {t('landing:banner.offer.description')}
                  </p>
                </div>
              </div>

              <MyButton onClick={onClick} className="w-100 mt-5">
                {t('landing:banner.offer.cta')}
              </MyButton>
            </div>
          </div>
          <div className="col-md-6 h-100 d-flex flex-column justify-content-center align-items-center p-5 order-1 order-md-2">
            <h1 
              className="banner__section__title"
              dangerouslySetInnerHTML={{ __html: t('landing:banner.title') }}
            />
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};
